export const GET_MODULES_CONFIG_SUCCESS = 'GET_MODULES_CONFIG_SUCCESS';
export const GET_MODULES_CONFIG_FAILURE = 'GET_MODULES_CONFIG_FAILURE';
